module.exports = __webpack_public_path__ + "static/media/sh.c79541ab.png";